import React  from "react";
import Modal from 'react-bootstrap/Modal';

const ModalBody = (props) => {
    const { children} = props
    return (
        <Modal.Body>
        {children}
        </Modal.Body>
    )
}

export default ModalBody;